'use client';

import { MarkdownViewer } from '@/components/markdown/markdown-viewer';

export function MarkdownContent({ content }: { content: string }) {
  return <MarkdownViewer content={content} compact />;
}
